import { AppNavigationItem } from '../models/app-navigation-item.model';
import { Permission } from '../../authorization/definitions/permission.enum';

export const primaryNavigationItems: Array<AppNavigationItem> = [
  {
    label: 'Institutions',
    path: '/institutions',
    permissions: [Permission.ViewInstitutions],
  },
  {
    label: 'Users',
    path: '/users',
    permissions: [Permission.ViewUsers],
  },
  {
    label: 'Scenarios',
    path: '/scenarios',
    permissions: [Permission.ViewScenarios],
  },
  {
    label: 'Scenario Packages',
    path: '/scenario-packages',
    permissions: [Permission.ViewScenarioPackages],
  },
  {
    label: 'Reporting Codes',
    path: '/reporting-codes',
    permissions: [Permission.ViewReportingCodes],
  },
  {
    label: 'Downloads',
    path: '/downloads',
    permissions: [Permission.ViewDownloads],
  },
  {
    label: 'Help',
    path: '/help',
    permissions: [Permission.ViewHelp],
  },
  {
    label: 'Administration',
    path: '/administration',
    permissions: [Permission.ViewAdministration],
  },
];
